import Appbody from "../components/Appbody";
const Home = () => {
  return <Appbody />;
};

export default Home;
